import cityLagLat from './../../map/common/baseData/chinaCity.json';

const data = [{
        "流出省份": "河北省",
        "流入省份": "北京市",
        "数量": "8081"
    },
    {
        "流出省份": "河南省",
        "流入省份": "北京市",
        "数量": "3068"
    },
    {
        "流出省份": "山东省",
        "流入省份": "北京市",
        "数量": "2800"
    },
    {
        "流出省份": "山西省",
        "流入省份": "北京市",
        "数量": "2582"
    },
    {
        "流出省份": "辽宁省",
        "流入省份": "北京市",
        "数量": "1777"
    },
    {
        "流出省份": "黑龙江省",
        "流入省份": "北京市",
        "数量": "1372"
    },
    {
        "流出省份": "内蒙古自治区",
        "流入省份": "北京市",
        "数量": "1157"
    },
    {
        "流出省份": "四川省",
        "流入省份": "北京市",
        "数量": "1147"
    },
    {
        "流出省份": "广东省",
        "流入省份": "北京市",
        "数量": "1066"
    },
    {
        "流出省份": "吉林省",
        "流入省份": "北京市",
        "数量": "964"
    },
    //---"流入省份": "广东省",
    {
        "流出省份": "湖南省",
        "流入省份": "广东省",
        "数量": "18120"
    },
    {
        "流出省份": "广西壮族自治区",
        "流入省份": "广东省",
        "数量": "11096"
    },
    {
        "流出省份": "江西省",
        "流入省份": "广东省",
        "数量": "7974"
    },
    {
        "流出省份": "河南省",
        "流入省份": "广东省",
        "数量": "6722"
    },
    {
        "流出省份": "四川省",
        "流入省份": "广东省",
        "数量": "5562"
    },
    {
        "流出省份": "山东省",
        "流入省份": "广东省",
        "数量": "3899"
    },
    {
        "流出省份": "湖北省",
        "流入省份": "广东省",
        "数量": "3369"
    },
    {
        "流出省份": "福建省",
        "流入省份": "广东省",
        "数量": "3278"
    },
    {
        "流出省份": "河北省",
        "流入省份": "广东省",
        "数量": "3137"
    },
    {
        "流出省份": "贵州省",
        "流入省份": "广东省",
        "数量": "3051"
    },
    // ---  "流入省份": "黑龙江",

    {
        "流出省份": "河南省",
        "流入省份": "黑龙江",
        "数量": "2618"
    },
    {
        "流出省份": "山东省",
        "流入省份": "黑龙江",
        "数量": "2136"
    },
    {
        "流出省份": "河北省",
        "流入省份": "黑龙江",
        "数量": "1989"
    },
    {
        "流出省份": "山西省",
        "流入省份": "黑龙江",
        "数量": "1187"
    },
    {
        "流出省份": "辽宁省",
        "流入省份": "黑龙江",
        "数量": "1072"
    },
    {
        "流出省份": "广东省",
        "流入省份": "黑龙江",
        "数量": "935"
    },
    {
        "流出省份": "四川省",
        "流入省份": "黑龙江",
        "数量": "901"
    },
    {
        "流出省份": "吉林省",
        "流入省份": "黑龙江",
        "数量": "845"
    },
    {
        "流出省份": "内蒙古自治区",
        "流入省份": "黑龙江",
        "数量": "779"
    },
    {
        "流出省份": "湖北省",
        "流入省份": "黑龙江",
        "数量": "779"
    }
];


/**
 * 查询城市
 * @param {*} provinceName 省份名称
 * @param {*} cityName 城市名称
 */
const findCity = (provinceName, cityName) => {
    const province = cityLagLat.find((a) => {
        return provinceName == a.name || a.name.indexOf(provinceName) > -1;
    });
    if (cityName == null) {
        return [province.log, province.lat]
    } else {
        const city = province.children.find((a) => {
            return cityName == a.name|| a.name.indexOf(cityName) > -1;
        });

        return [city.log, city.lat]
    }
}

const result = data.map((item) => {
    return {
        from: {
            name: item['流出省份'],
            coordinates: findCity(item['流出省份'])
        },
        to: {
            name: item['流入省份'],
            coordinates: findCity(item['流入省份'])
        },
        value: Number(item['数量']),
        _data: {
            ...item
        }
    }
})

result.sort((b, a) => {
    return a.value - b.value;
})

export default result;